<template>
    <v-dialog v-model="openMode" max-width="500px" content-class="mm-dialog" overlay-color="#0d2c6d"
        overlay-opacity="0.55" transition="dialog-bottom-transition">
        <v-card class="mm-dlg-card">
            <div class="mm-dlg-head">
                <div class="mm-dlg-head__main">
                    <div class="mm-dlg-head__icon" aria-hidden="true">
                        <v-icon color="white">mdi-delete-off-outline</v-icon>
                    </div>
                    <div>
                        <span class="mm-dlg-eyebrow">אישור פעולה</span>
                        <h2 class="mm-dlg-title">ביטול תהליך המחיקה</h2>
                    </div>
                </div>
                <button type="button" class="mm-dlg-close" @click="closeDialog" aria-label="סגור">
                    <v-icon small color="white">mdi-close</v-icon>
                </button>
            </div>

            <v-card-text class="mm-dlg-body">
                <div class="mm-restore-box">
                    <div class="mm-restore-icon">
                        <v-icon large color="#2e7d32">mdi-shield-check-outline</v-icon>
                    </div>
                    <h3 class="mm-restore-title">לבטל את תהליך המחיקה של המנוי?</h3>
                    <p class="mm-restore-text">המנוי יישאר פעיל ולא יימחק במועד המתוכנן.</p>
                </div>

                <div class="mm-dlg-section">
                    <div class="mm-dlg-section__title">
                        <span class="mm-dlg-section__bar"></span>
                        פרטי המנוי
                    </div>

                    <div class="mm-row">
                        <span class="mm-row__label">
                            <v-icon x-small class="ml-1" color="#94a3b8">mdi-sim-outline</v-icon>
                            מספר מנוי
                        </span>
                        <span class="mm-row__value mm-ltr">{{ item.manui_number || '—' }}</span>
                    </div>

                    <div class="mm-row">
                        <span class="mm-row__label">
                            <v-icon x-small class="ml-1" color="#94a3b8">mdi-calendar-clock</v-icon>
                            תאריך מחיקה מתוכנן
                        </span>
                        <span :class="['mm-row__value', isOverdue && 'mm-row__value--danger']">
                            {{ formattedDeletionDate }}
                            <span v-if="isOverdue" class="mm-row__flag">התאריך עבר</span>
                        </span>
                    </div>

                    <div class="mm-row">
                        <span class="mm-row__label">
                            <v-icon x-small class="ml-1" color="#94a3b8">mdi-account</v-icon>
                            בוטל על ידי
                        </span>
                        <span class="mm-row__value">{{ deletedByName }}</span>
                    </div>
                </div>
            </v-card-text>

            <div class="mm-dlg-foot">
                <v-progress-linear v-if="progressShow" indeterminate color="#2e7d32" height="3"
                    class="mm-dlg-progress" />
                <div class="mm-dlg-foot__actions">
                    <button type="button" class="mm-dlg-btn mm-dlg-btn--ghost" :disabled="progressShow"
                        @click="closeDialog">
                        <v-icon small>mdi-close</v-icon>
                        חזרה
                    </button>
                    <button type="button" class="mm-dlg-btn mm-dlg-btn--success" :disabled="progressShow"
                        @click="cancelDeleteProcess">
                        <v-icon small color="white">mdi-delete-off-outline</v-icon>
                        אישור
                    </button>
                </div>
            </div>
        </v-card>

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
    props: {
        item: Object,
        value: { type: Boolean, default: false },
    },
    components: {
        SnackBar,
    },
    data: () => ({
        progressShow: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
    }),

    methods: {
        async cancelDeleteProcess() {
            if (!this.item || !this.item._id) {
                this.showSnackBar("לא נמצא מזהה מנוי", "red");
                return;
            }
            try {
                this.progressShow = true;
                let token = localStorage.getItem("token");
                const myJSON = JSON.stringify({ manuiId: this.item._id });

                let api = process.env.VUE_APP_BASE_URL + "/manuim/cancle_delete";
                const res = await fetch(api, ApiServices.requestOptions("POST", myJSON, token));
                const jsonObject = await res.json().catch(() => ({}));
                this.progressShow = false;

                if (res.status >= 400) {
                    this.showSnackBar("שגיאה בביטול תהליך המחיקה: " + (jsonObject.message || ""), "red");
                } else if (res.status === 200) {
                    const updated = jsonObject.data || { deletedAt: null, deletedBy: null };
                    this.$emit("deleteCanceled", this.item, updated, "תהליך המחיקה בוטל, המנוי נשאר פעיל", "green");
                    this.openMode = false;
                }
            } catch (error) {
                this.progressShow = false;
                this.showSnackBar("Error cancel delete: " + error, "red");
            }
        },
        closeDialog() {
            this.openMode = false;
        },
        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true
        },
    },
    computed: {
        openMode: {
            get() {
                return this.value
            },
            set(v) {
                return this.$emit('input', v)
            }
        },
        deletionDate() {
            if (!this.item || !this.item.deletedAt) return null;
            const d = new Date(this.item.deletedAt);
            return isNaN(d.getTime()) ? null : d;
        },
        formattedDeletionDate() {
            return this.deletionDate ? this.deletionDate.toLocaleDateString('he-IL') : '—';
        },
        isOverdue() {
            if (!this.deletionDate) return false;
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const t = new Date(this.deletionDate);
            t.setHours(0, 0, 0, 0);
            return t.getTime() < today.getTime();
        },
        deletedByName() {
            return (this.item && this.item.deletedBy && this.item.deletedBy.name) || 'לא ידוע';
        },
    },
}
</script>

<style scoped>
.mm-dialog {
    border-radius: 20px !important;
    overflow: hidden;
}

.mm-dlg-card {
    --mm-navy: #0d2c6d;
    --mm-purple: #8066f0;
    --mm-green: #2e7d32;
    --mm-border: #eef2f7;
    --mm-text: #0f172a;
    --mm-text-soft: #475569;
    --mm-text-mute: #94a3b8;
    font-family: 'Assistant', 'Heebo', system-ui, sans-serif;
    direction: rtl;
    border-radius: 20px !important;
    overflow: hidden;
    background: #ffffff !important;
}

.mm-dlg-head {
    position: relative;
    background:
        radial-gradient(800px 200px at 90% -40%, rgba(253, 183, 33, 0.08), transparent 60%),
        linear-gradient(135deg, #0d2c6d 0%, #142f78 55%, #1a3a8a 100%);
    color: #fff;
    padding: 18px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.mm-dlg-head__main {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
}

.mm-dlg-head__icon {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.22);
    display: grid;
    place-items: center;
    color: #fff;
}

.mm-dlg-eyebrow {
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.65);
    margin-bottom: 1px;
}

.mm-dlg-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: -0.01em;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mm-dlg-close {
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.18);
    color: #fff;
    cursor: pointer;
    display: grid;
    place-items: center;
    transition: background 0.2s, transform 0.2s;
}

.mm-dlg-close:hover {
    background: rgba(255, 255, 255, 0.18);
    transform: rotate(90deg);
}

.mm-dlg-body {
    padding: 24px 28px 20px !important;
    background: #fbfcfe;
    max-height: 65vh;
    overflow-y: auto;
}

/* ── בלוק ההודעה העליון ── */
.mm-restore-box {
    text-align: center;
    padding: 2px 0 20px;
}

.mm-restore-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 14px;
    border-radius: 18px;
    background: #eaf6ea;
    display: grid;
    place-items: center;
}

.mm-restore-title {
    margin: 0 0 8px;
    color: var(--mm-text);
    font-size: 1.05rem;
    font-weight: 800;
}

.mm-restore-text {
    margin: 0;
    color: var(--mm-text-soft);
    font-size: 0.9rem;
    line-height: 1.7;
}

/* ── כרטיס פרטי המנוי ── */
.mm-dlg-section {
    padding: 16px 18px 8px;
    background: #ffffff;
    border: 1px solid var(--mm-border);
    border-radius: 14px;
    box-shadow: 0 12px 28px -24px rgba(15, 23, 42, 0.35);
}

.mm-dlg-section__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.92rem;
    font-weight: 700;
    color: var(--mm-navy);
    margin: 0 0 10px;
}

.mm-dlg-section__bar {
    width: 3px;
    height: 16px;
    background: linear-gradient(180deg, var(--mm-navy), var(--mm-purple));
    border-radius: 2px;
}

.mm-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 9px 0;
    border-bottom: 1px dashed #f1f4f8;
}

.mm-row:last-child {
    border-bottom: none;
}

.mm-row__label {
    display: flex;
    align-items: center;
    color: var(--mm-text-soft);
    font-size: 0.84rem;
    white-space: nowrap;
}

.mm-row__value {
    display: flex;
    align-items: center;
    gap: 7px;
    color: var(--mm-text);
    font-size: 0.87rem;
    font-weight: 700;
    text-align: left;
}

.mm-row__value--danger {
    color: #b42318;
}

.mm-row__flag {
    padding: 2px 7px;
    border-radius: 999px;
    background: #fff1f0;
    color: #b42318;
    font-size: 0.68rem;
    font-weight: 800;
    white-space: nowrap;
}

.mm-ltr {
    direction: ltr;
    letter-spacing: 0.02em;
}

/* ── פוטר ── */
.mm-dlg-foot {
    background: #ffffff;
    border-top: 1px solid var(--mm-border);
}

.mm-dlg-progress {
    display: block;
}

.mm-dlg-foot__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 22px;
}

.mm-dlg-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 22px;
    border-radius: 10px;
    border: none;
    font-family: inherit;
    font-weight: 700;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.mm-dlg-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.mm-dlg-btn--ghost {
    background: transparent;
    color: var(--mm-text-soft);
    border: 1px solid #e3e8ef;
}

.mm-dlg-btn--ghost:hover:not(:disabled) {
    background: #f8fafc;
    color: var(--mm-text);
}

.mm-dlg-btn--success {
    background: linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%);
    color: #fff;
    box-shadow: 0 6px 14px -4px rgba(46, 125, 50, 0.45);
}

.mm-dlg-btn--success:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.08);
}

@media (max-width: 600px) {
    .mm-dlg-head {
        padding: 14px 18px;
    }

    .mm-dlg-title {
        font-size: 1rem;
    }

    .mm-dlg-body {
        padding: 18px 18px 16px !important;
    }

    .mm-dlg-section {
        padding: 14px 14px 6px;
    }

    .mm-row {
        align-items: flex-start;
        flex-direction: column;
        gap: 4px;
    }

    .mm-dlg-foot__actions {
        padding: 12px 16px;
    }

    .mm-dlg-btn {
        padding: 9px 16px;
        font-size: 0.85rem;
    }
}
</style>